// AI聊天
import React from 'react'

import { Divider } from 'antd';

import Cache from '../../frame/Cache';
import Config from '../../config/Config';
import Widget from '../../widget/Widget';
import WidgetAjax from '../../widget/WidgetAjax';

import AIChatInput from '../component/AIChatInput';
import Chat from '../component/Chat';
import ChatHistory from '../component/ChatHistory';
import Resume from '../component/Resume';

let filePath = Config.getFilePath();

class AIChat extends React.Component 
{
    constructor(props)
    {
        super(props);

        const { scene = "resume" } = props.location?.state || {}; 

        let chatPageType = sessionStorage.getItem("_chart_page_type_");
        let seesionItem = sessionStorage.getItem("_chat_session_item_");

        let sessionId, sessionTitle;
        if( seesionItem )
        {
            seesionItem = JSON.parse(seesionItem);
            sessionId = seesionItem.id;
            sessionTitle = seesionItem.title;
        }

        this.state = {
            basePath: Config.getBasePath(),
            sourcePath: Config.getSourcePath(),
            chatPageType: chatPageType || "new-session",
            scene:scene,
            sessionId: sessionId,
            sessionTitle:sessionTitle
        }

        // 获取组件自身
        this.scrollRef = React.createRef();

        this.resumeRef = React.createRef();
    }

    componentDidMount = () => {

        Widget.loadClass();

        let userInfo = sessionStorage.getItem("_user_info_");

        if( userInfo )
        {
            userInfo = JSON.parse(userInfo);

            this.setState({userInfo:userInfo});
        }
    }

    componentWillUnmount()
    {
        sessionStorage.removeItem("_chart_page_type_");
        sessionStorage.removeItem("_chat_session_item_");
    }

    AIChatInputNotify = ( e, type) => {

        switch( type )
        {
            case "onChange":
            {
                this.setState({chatContent: e.target.value});
                break;
            }
            case "send":
            case "onKeyUp":
            {
                this.send();
                break;
            }
            case "link":
            {
                this.link();
                break;
            }
        }
    }

    send = () => {

        const { chatContent } = this.state;

        if( chatContent )
        {
            sessionStorage.setItem("_chart_page_type_", "chat");
            this.setState({chatContent:chatContent, chatPageType:"chat"});
        }

    }

    link = () => {

    }

    login = () => {

        this.props.history.push({pathname:"/login?redirectURL=/home/ai-chat"})
        window.location.reload(); 
    }

    createNewSession = () => {

        sessionStorage.setItem("_chart_page_type_", "new-session");
        this.setState({chatPageType:"new-session", chatContent:undefined, sessionId:undefined});

    }

    historySession = () => {

        sessionStorage.setItem("_chart_page_type_", "history");
        this.setState({chatPageType:"history"});
    }

    resumeChat = () => {

    }

    recommendChat = () => {

    }

    careerChat = () => {

    }

    notify = (value, type ) => {

        if( type==="new-session" )
        {
            this.createNewSession();
        }
        else if(  type==="update-resume" )
        {
            this.resumeRef.current.getUserInfo();
        }
    }

    historyNotify = (item, type) => {

        if( type==="history-click")
        {
            sessionStorage.setItem("_chart_page_type_", "chat");

            sessionStorage.setItem("_chat_session_item_", JSON.stringify(item));

            this.setState({chatPageType:"chat", sessionId:item.id, sessionTitle:item.title});
        }
    }

    resumeCallback = ( resumeInfo, type ) => {

        if( type==="resume-info")
        {
            this.setState({resumeInfo:resumeInfo});
        }
        
    }


    render()
    {
        const {sourcePath, userInfo={}, chatPageType="new-session", sessionId, role="ai", chatContent, sessionTitle, scene, resumeInfo} = this.state;

        return (
            <div className="sf-page" component-data="ai-chat">
                <div className="sf-chat-left">
                    <div className="sf-chat-left-item">
                        <div className="sf-chat-left-item-icon" onClick={this.login}><img src={require("./../../img/" + sourcePath +"/ai-chat/user.png")}></img></div>
                        <div className="sf-chat-left-item-font">{userInfo.realname}</div>
                    </div>
                    <div className="sf-chat-left-item">
                        <div className="sf-chat-left-item-icon" onClick={this.createNewSession} ><img src={require("./../../img/" + sourcePath +"/ai-chat/session.png")}></img></div>
                        <div className="sf-chat-left-item-font">新对话</div>
                    </div>
                    <div className="sf-chat-left-item">
                        <div className="sf-chat-left-item-icon" onClick={this.historySession}><img src={require("./../../img/" + sourcePath +"/ai-chat/history.png")}></img></div>
                        <div className="sf-chat-left-item-font">历史</div>
                    </div>

                    <Divider className="sf-divider" />
                    
                    <div className="sf-chat-left-item">
                        <div className="sf-chat-left-item-icon" onClick={this.resumeChat}><img src={require("./../../img/" + sourcePath +"/ai-chat/resume.png")}></img></div>
                        <div className="sf-chat-left-item-font">简历</div>
                    </div>
                    <div className="sf-chat-left-item">
                        <div className="sf-chat-left-item-icon" onClick={this.recommendChat}><img src={require("./../../img/" + sourcePath +"/ai-chat/recommend.png")}></img></div>
                        <div className="sf-chat-left-item-font">推荐</div>
                    </div>
                    <div className="sf-chat-left-item">
                        <div className="sf-chat-left-item-icon" onClick={this.careerChat}><img src={require("./../../img/" + sourcePath +"/ai-chat/tree.png")}></img></div>
                        <div className="sf-chat-left-item-font">职业树</div>
                    </div>
                </div>

                <>
                {
                    chatPageType==="new-session" ? 
                    <div className="sf-first-seesion">
                        <div className='sf-chat-title'>
                            <div className='sf-chat-first-title'>hi～我是AI职业导师，很高兴能和你对话！</div>

                            <div className='sf-chat-sub-title'>我可以帮你生成简历、推荐岗位、做职业规划等，快来把你的诉求告诉我吧</div>
                        </div>

                        <div className='sf-chat-input'>
                            <AIChatInput notify={this.AIChatInputNotify}></AIChatInput>
                        </div>
                        
                    </div> 
                    :  chatPageType==="chat" ? 
                        <>
                        {
                            scene==="resume" ?
                                <div className="sf-ai-resume">
                                    <div className="sf-seesion" ref={this.scrollRef} >
                                        <Chat sessionId={sessionId} sessionTitle={sessionTitle} history={this.props.history} role={role} 
                                            chatContent={chatContent} scrollRef={this.scrollRef} notify={this.notify} scene={scene} resumeInfo={resumeInfo}></Chat>
                                    </div>

                                    <div className="sf-ai-resume-body">
                                        <Resume ref={this.resumeRef} notify={this.resumeCallback}></Resume>
                                    </div>
                                </div>  
                                
                            :
                                <div className="sf-seesion" ref={this.scrollRef} >
                                    <Chat sessionId={sessionId} sessionTitle={sessionTitle} history={this.props.history} role={role} 
                                        chatContent={chatContent} scrollRef={this.scrollRef} notify={this.notify} scene={scene}></Chat>
                                </div>
                        }
                        </>
                       
                    :  chatPageType==="history" ?
                        <div className="sf-seesion-history">
                            <ChatHistory notify={this.historyNotify} history={this.props.history} scene={scene}></ChatHistory>
                        </div>
                    :
                    <></>
                }
                </>
            </div>
        );
    }
}

export default AIChat;